import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import Users from './Users';
import Servers from './Servers';
import Codes from './Codes';
import Nodes from './Nodes';
import Settings from './Settings';
import GameManagement from './GameManagement';
import GameParameterCommentsManagement from './GameParameterCommentsManagement';
import ModActivationCodes from './ModActivationCodes';
import TaobaoReceiptCodes from './TaobaoReceiptCodes';
import ErrorMonitor from '../../components/ErrorMonitor';
import SimpleErrorViewer from '../../components/SimpleErrorViewer';

const Admin: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/users" element={<Users />} />
      <Route path="/servers" element={<Servers />} />
      <Route path="/nodes" element={<Nodes />} />
      <Route path="/codes" element={<Codes />} />
      <Route path="/mod-activation-codes" element={<ModActivationCodes />} />
      <Route path="/taobao-receipt-codes" element={<TaobaoReceiptCodes />} />
      <Route path="/games" element={<GameManagement />} />
      <Route path="/game-parameter-comments" element={<GameParameterCommentsManagement />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/error-monitor" element={<ErrorMonitor />} />
      <Route path="/simple-errors" element={<SimpleErrorViewer />} />
    </Routes>
  );
};

export default Admin;



